/**
 * Single source of truth for what a visit of a given provider type may carry.
 *
 * Read by the registration form's render gates, the provider-switch clear, AND
 * the submit guards so the three can never drift apart. The blunder this
 * prevents: a procedure selected for a doctor (OPD) visit must not survive a
 * switch to a Lab Visit and get billed there.
 *
 * @param {string} providerType - 'DOCTOR' (OPD) | 'NURSE' | 'LAB'
 * @returns {{ procedures: boolean, lab: boolean, consultFee: boolean }}
 */
export function visitTypeCapabilities(providerType) {
  const t = (providerType || '').toUpperCase();
  return {
    // Treatment-plan procedures: OPD (doctor) and Nurse visits — never Lab.
    procedures: t !== 'LAB',
    // Lab investigations: only a Lab Visit.
    lab: t === 'LAB',
    // Consultation fee: doctor visits only (Nurse / Lab are doctor-less).
    consultFee: t === 'DOCTOR',
  };
}
